import { createReducer, INITIAL_STATE } from '../../../shared/redux';

import { API_INTEGRATE_URL, API_GET_DATA_URL } from './pipedrive.constants';

export const PIPEDRIVE_SAVE_INTEGRATION_REQUEST_CALLED = '@integrations/pipedrive/SAVE_INTEGRATION_REQUEST_CALLED';
export const PIPEDRIVE_SAVE_INTEGRATION_REQUEST_START = '@integrations/pipedrive/SAVE_INTEGRATION_REQUEST_START';
export const PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS = '@integrations/pipedrive/SAVE_INTEGRATION_REQUEST_SUCCESS';
export const PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR = '@integrations/pipedrive/SAVE_INTEGRATION_REQUEST_ERROR';
export const PIPEDRIVE_GET_DATA_REQUEST_CALLED = '@integrations/pipedrive/GET_DATA_REQUEST_CALLED';
export const PIPEDRIVE_GET_DATA_REQUEST_START = '@integrations/pipedrive/GET_DATA_REQUEST_START';
export const PIPEDRIVE_GET_DATA_REQUEST_SUCCESS = '@integrations/pipedrive/GET_DATA_REQUEST_SUCCESS';
export const PIPEDRIVE_GET_DATA_REQUEST_ERROR = '@integrations/pipedrive/GET_DATA_REQUEST_ERROR';

export const getPipedriveState = state => ({
    ...state.integrations.pipedrive,
});

type PipedriveintegrationData = {
    apiToken: string
    clientId: string
}

export const savePipedriveIntegration = ({ apiToken, clientId }:PipedriveintegrationData) => ({
    type: PIPEDRIVE_SAVE_INTEGRATION_REQUEST_CALLED,
    actionTypes: {
        start: PIPEDRIVE_SAVE_INTEGRATION_REQUEST_START,
        fail: PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR,
        success: PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS,
    },
    config: {
        url: API_INTEGRATE_URL,
        method: 'POST',
        data: {
            api_token: apiToken,
            client_id: clientId,
        },
    },
});

export const getPipedriveData = ({ clientId }) => ({
    type: PIPEDRIVE_GET_DATA_REQUEST_CALLED,
    actionTypes: {
        start: PIPEDRIVE_GET_DATA_REQUEST_START,
        success: PIPEDRIVE_GET_DATA_REQUEST_SUCCESS,
        fail: PIPEDRIVE_GET_DATA_REQUEST_ERROR,
    },
    config: {
        url: API_GET_DATA_URL,
        method: 'GET',
        params: {
            client_id: clientId,
        },
    },
});

export type State = {
  loading: boolean
  submitting: boolean
  integrationData: string
};

const initialState: State = {
    loading: true,
    submitting: false,
    integrationData: '',
};

export const pipedriveReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_START]: (state: State): State => ({
        ...state,
        submitting: true,
    }),
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [PIPEDRIVE_SAVE_INTEGRATION_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [PIPEDRIVE_GET_DATA_REQUEST_START]: (state: State): State => ({
        ...state,
        loading: true,
    }),
    [PIPEDRIVE_GET_DATA_REQUEST_SUCCESS]: (state: State, action): State => ({
        ...state,
        loading: false,
        integrationData: action.payload.data.api_token,
    }),
    [PIPEDRIVE_GET_DATA_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        loading: false,
    }),
});
